export default __webpack_public_path__ + "static/media/fi-br-playing-cards.356eb887.svg";